import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{attrs:{"flat":""}},[_c(VCardTitle,{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.$t('components.account.settings.displaySettings.title'))+" ")]),_c(VCardText,[_c(VContainer,{attrs:{"fluid":""}},[_c(VSwitch,{attrs:{"label":_vm.$t(
            'components.account.settings.displaySettings.showNavigationDrawer.label'
          ),"hint":_vm.$t(
            'components.account.settings.displaySettings.showNavigationDrawer.hint'
          ),"persistent-hint":""},model:{value:(_vm.showNavigationDrawer),callback:function ($$v) {_vm.showNavigationDrawer=$$v},expression:"showNavigationDrawer"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }